import * as Yup from "yup";

export const ProductoFormSchema = Yup.object().shape({
    idproyecto: Yup.string().test('requiredIfProyecto', 'Se debe seleccionar un proyecto', function (value) {
        const tiene = this.parent.tieneProyecto;
        const idpro = this.parent.idproyecto;
        if (tiene === 'S') {
            return idpro > 0;
        }
        return true;
    }),
    tipomotivo: Yup.string().notOneOf(['0', ''], 'No puede ser ninguno'),
    motivo: Yup.string().test('requiredIfmotivo', 'La explicación no puede quedar en blanco.', function (value) {
        const tiene = this.parent.tieneProyecto;
        const motivo: string = this.parent.motivo;
        if (tiene === 'N') {
            return motivo !== undefined && motivo.length > 0;
        }
        return true;
    }).test('motivoLength', 'La longitud del motivo no puede exceder los 300 caracteres.', function (value) {
        const motivo = this.parent.motivo || ''; // Asegúrate de que motivo sea una cadena, si es nulo, lo convierte a una cadena vacía

        // Verifica si la longitud del motivo es igual o inferior a 300 caracteres
        return motivo.trim().length <= 300;
    }),
    titulo: Yup.string().required('El titulo es requerido.')
        .test('requiredIfLegth', 'Se excedio el máximo de caracteres 250', function (value) {
            return value !== undefined ? value.length <= 250 : true;
        }),
    tipo: Yup.number().required('Se debe seleccionar tipo').positive('Debe escoger un Tipo de Producto').min(24, 'Debe escoger un Tipo de Producto Valido'),
    anio: Yup.number().test('anioRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 27, 45, 46, 47].includes(tipo)) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    subclase: Yup.number().test('subcalseRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([32, 33, 45, 47].includes(tipo)) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    url: Yup.string().test('requiredIfTipo', 'El URL de la publicación es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 27, 28, 46, 47].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 200', function (value) {
        return value !== undefined ? value.length <= 200 : true;
    }),
    numsolicitud: Yup.string().test('requiredIfTipo', 'Campo requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([33, 34].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 100', function (value) {
        return value !== undefined ? value.length <= 100 : true;
    }),
    nombreRevista: Yup.string().test('requiredIfTipo', 'Campo requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 27, 31, 35, 36, 46].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLeght', 'Se excedio el máximo de caracteres 100', function (value) {
        return value !== undefined ? value.length <= 100 : true;
    }),
    codISSN: Yup.string().test('requiredIfTipo', 'El Codigo ISSN es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([26, 28, 31].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLeght', 'Se excedio el máximo de caracteres 100', function (value) {
        return value !== undefined ? value.length <= 100 : true;
    }),
    codigoproducto: Yup.string().test('requiredIfTipo', 'El Codigo de producto es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([40].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLeght', 'Se excedio el máximo de caracteres 50', function (value) {
        return value !== undefined ? value.length <= 50 : true;
    }),
    urlRevista: Yup.string().test('requiredIfTipo', 'El URL de la revista es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 46].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 150', function (value) {
        return value !== undefined ? value.length <= 150 : true;
    }),
    //manejo de indexación
    bdrevista: Yup.number().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 46].includes(tipo)) {
            return value !== undefined ? value > 0 : false;
        }
        return true;
    }),
    isindex: Yup.number().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([37].includes(tipo)) {
            return value !== undefined ? value >= 0 : false;
        }
        return true;
    }),
    cuartil: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    cuartilCiteScore: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const banderaIndex = (this.parent.bdrevista === 3799 || this.parent.bdrevista === 3801);
        if ([24].includes(tipo) && banderaIndex) {
            return !!value;
        }
        return true;
    }),
    impactoIndex: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const banderaIndex = (this.parent.bdrevista === 3799 || this.parent.bdrevista === 3801);
        if ([24].includes(tipo) && banderaIndex) {
            return !!value;
        }
        return true;
    }),
    impactoSJR: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    esPrimerDecilCiteScore: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    volumen: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 28, 46].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    paginas: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 28, 45, 46].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 30', function (value) {
        return value !== undefined ? value.length <= 30 : true;
    }),
    palabrasClave: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3831, 3834];
        if ([24, 25, 26, 29, 30, 31, 32, 34, 41, 42, 45, 46].includes(tipo)) {
            return !!value;
        } else if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIftipolenght', 'Se excedio el máximo de caracteres 200', function (value) {
        return value !== undefined ? value.length <= 200 : true;
    }),
    resumen: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3831, 3834, 3835];
        if ([24, 25, 26, 29, 30, 32, 34, 35, 38, 41, 42, 45, 46].includes(tipo)) {
            return !!value;
        } else if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIfTipoLeght', 'Se excedio el máximo de caracteres 3000', function (value) {
        return value !== undefined ? value.length <= 3000 : true;
    }),
    especificacion: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3833];
        if ([33, 35, 37, 39, 40].includes(tipo)) {
            return !!value;
        } else if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIfTipo', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
    }),
    doi: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 46, 47].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfTipo', 'El formato no debe contener "https://doi.org/".', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 46, 47].includes(tipo)) {
            return value !== undefined ? !value.startsWith('https://doi.org/') : false;
        }
        return true;
    }).test('requiredIfTipo', 'Se excedio el máximo de caracteres 50', function (value) {
        return value !== undefined ? value.length <= 50 : true;
    }),
    editorial: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([28].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIftipolenght', 'Se excedio el máximo de caracteres 150', function (value) {
        return value !== undefined ? value.length <= 150 : true;
    }),
    estado: Yup.number().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([37].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    frecuencia: Yup.number().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([37].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    asistObjetiv: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3830, 3835];
        if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
    }),
    innovaVerific: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3830];
        if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
    }),
    logrosSistemac: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3830, 3831, 3834];
        if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
    }),
    retosComunic: Yup.string().test('requiredIfTipo', 'El campo es requerido.', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3830];
        if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
    }),
    fechapublicacion: Yup.string().test('requiredIfTipo', 'La fecha es requerida', function (value) {
        const tipo = this.parent.tipo;
        const estado = this.parent.estado;
        const subclase = this.parent.subclase;
        const patentes = [3830, 3831, 3834]
        if ([24, 25, 26, 27, 28, 32, 34, 46].includes(tipo)) {
            return !!value;
        }
        else if ([37].includes(tipo) && estado === 1) {
            return !!value;
        } else if ([47].includes(tipo) && patentes.includes(subclase)) {
            return !!value;
        }
        return true;
    }),
    fevento: Yup.string().test('requiredIfTipo', 'La fecha es requerida', function (value) {
        const tipo = this.parent.tipo;
        const estado = this.parent.estado;
        if ([29, 30, 31, 32, 33, 34, 41].includes(tipo)) {
            return !!value;
        }
        else if ([37].includes(tipo) && estado === 2) {
            return !!value;
        }
        return true;
    }),
    nevento: Yup.string().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([31, 32, 34, 36, 38, 39].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 150', function (value) {
        return value !== undefined ? value.length <= 150 : true;
    }),
    levento: Yup.string().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([31, 36, 37, 38, 39].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 200', function (value) {
        return value !== undefined ? value.length <= 200 : true;
    }),
    tipolab: Yup.string().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([38].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 150', function (value) {
        return value !== undefined ? value.length <= 150 : true;
    }),
    idunidad: Yup.number().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patente = [3835]
        if ([37, 38].includes(tipo)) {
            return !!value;
        } else if ([47].includes(tipo) && patente.includes(subclase)) {
            return !!value;
        }
        return true;
    }),
    areaimplementacion: Yup.string().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([40].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 100', function (value) {
        return value !== undefined ? value.length <= 100 : true;
    }),
    iddecinvareaconocimiento: Yup.number().test('anioRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 32, 34, 44, 45, 46].includes(tipo)) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    lineainvestigacion: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 32, 34, 44, 45, 46].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 200', function (value) {
        return value !== undefined ? value.length <= 200 : true;
    }),
    marca: Yup.string().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([37].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 50', function (value) {
        return value !== undefined ? value.length <= 50 : true;
    }),
    modelo: Yup.string().test('requiredIfTipo', 'Campo requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([37].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 30', function (value) {
        return value !== undefined ? value.length <= 30 : true;
    }),
    iddecinvobjods: Yup.number().test('odsRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([32, 33, 34, 44].includes(tipo)) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    codarea: Yup.number().test('anioRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 32, 34, 44, 45, 46].includes(tipo)) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    codsubarea: Yup.number().test('anioRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 32, 34, 44, 45, 46].includes(tipo)) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    codsubareadetallada: Yup.number().test('anioRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 32, 34, 44, 45, 46].includes(tipo)) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    idprograma: Yup.number().test('ifRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        const espol = this.parent.espol;
        if ([29, 30, 42].includes(tipo) && espol) {
            return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    nombreprograma: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([29, 30, 42].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 150', function (value) {
        return value !== undefined ? value.length <= 150 : true;
    }),
    instituciontitularPG: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([29, 30, 42].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 150', function (value) {
        return value !== undefined ? value.length <= 150 : true;
    }),
    inventario: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([37].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 20', function (value) {
        return value !== undefined ? value.length <= 20 : true;
    }),
    revisionpares: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([28].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    serie: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([37].includes(tipo)) {
            return !!value;
        }
        return true;
    }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 10', function (value) {
        return value !== undefined ? value.length <= 10 : true;
    }),
    objGeneral: Yup.string().test('requiredIfTipo', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        const subclase = this.parent.subclase;
        const patentes = [3832]
        if ([29, 30, 41, 42].includes(tipo)) {
            return !!value;
        } else if ([47].includes(tipo) && patentes.includes(subclase)) {
            return !!value;
        }
        return true;
    }).test('requiredIfTipo', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
    }),
    adjunto: Yup.string().test('requiredIfTipo', 'El archivo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    adjunto2: Yup.string().test('requiredIfTipo', 'El archivo es requerido', function (value) {
        const tipo = this.parent.tipo;
        const revisionPares = this.parent.revisionpares;
        if ([29, 30, 31, 32, 33, 34, 36, 39, 42, 44, 46].includes(tipo)) {
            return !!value;
        }
        else if ([28].includes(tipo) && revisionPares == 'S') {
            return !!value;
        }
        return true;
    }),
    adjunto3: Yup.string().test('requiredIfTipo', 'El archivo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([32].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    adjunto4: Yup.string().test('requiredIfTipo', 'El archivo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([32].includes(tipo)) {
            return !!value;
        }
        return true;
    }),
    colaboradores: Yup.array().of(
        Yup.object().shape({
            cedula: Yup.string()
                .required('La identificación es requerida')
                .max(20, 'Se excedió el máximo de caracteres (20)'),
            // cedula: Yup.string().required('La identificación es requerida')
            //     .test('requiredIfcedula', 'La cédula debe tener 10 dígitos', function (value) {
            //         const tipocolaborador = this.parent.tipocolaborador;
            //         const cedula = value;
            //         if (tipocolaborador === 1) {
            //             return Boolean(cedula && cedula.match(/^\d{10}$/));
            //         }
            //         return true;
            //     }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 20', function (value) {
            //         return value !== undefined ? value.length <= 20 : true;
            //     }),
            nombre: Yup.string().required('El nombre completo es requerido')
                .test('requiredIfLegth', 'Se excedio el máximo de caracteres 100', function (value) {
                    return value !== undefined ? value.length <= 100 : true;
                }),
            institucion: Yup.string().when('tipocolaborador', {
                is: 1,
                then: (schema) => schema.oneOf(['Espol', 'ESPOL'], 'Es colaborador interno, la institución solo puede ser Espol').required('Es requerido'),
                otherwise: (schema) => schema.notOneOf(['Espol', 'ESPOL'], 'Es colaborador externo, indique la institución').required('Es requerido'),
            }).test('requiredIfLegth', 'Se excedio el máximo de caracteres 70', function (value) {
                return value !== undefined ? value.length <= 70 : true;
            }),
            email: Yup.string().email('Correo no válido').required('Correo es requerido'),
            tipocolaborador: Yup.number().notOneOf([0], 'No puede ser ninguno').required('Indicar si el colaborador es de espol'),
            idunidad: Yup.number().when('tipocolaborador', {
                is: 1,
                then: (schema) => schema.notOneOf([0], 'Es colaborador interno, debe seleccionar una unidad de Espol').required('Es requerido'),
                otherwise: (schema) => schema.oneOf([0], 'Es colaborador externo, no puede tener unidad espol').required('Es requerido'),
            }),
            tipoparticipacion: Yup.number().notOneOf([0], 'No puede ser ninguno').required('Rol es requerido'),
        })
    ).min(1, 'Debe haber al menos un colaborador en la lista'),
    solicitantes: Yup.array().of(
        Yup.object().shape({
            nombre: Yup.string().required('Nombres son requeridos')
                .test('requiredIfLegth', 'Se excedio el máximo de caracteres 150', function (value) {
                    return value !== undefined ? value.length <= 150 : true;
                }),
            porcentajetitularidad: Yup.number().typeError('Ingrese un número')
                .min(0, 'El porcentaje debe ser mayor o igual a 0')
                .max(100, 'El porcentaje debe ser menor o igual a 100')
                .test('is-integer', 'El valor debe ser un número entero', (value) => {
                    if (value !== undefined && value !== null) {
                        return Number.isInteger(value);
                    }
                    return true; // Si no hay valor, no se valida (esto es manejado por required si es necesario)
                })
        })
    ).test('min-length', 'Debe haber al menos un Solicitante en la lista', function (value) {
        const tipo = this.parent.tipo;
        if ([32, 33, 34, 45].includes(tipo)) {
            return value && value.length > 0;
        }
        return true;
    }),
    objEspecificos: Yup.array().of(
        Yup.object().shape({
            objetivo: Yup.string().required('Objetivo son requeridos')
                .test('requiredIfLegth', 'Se excedio el máximo de caracteres 500', function (value) {
                    return value !== undefined ? value.length <= 500 : true;
                }),
        }))
        .test('min-length', 'Debe haber al menos un objetivo en la lista', function (value) {
            const tipo = this.parent.tipo;
            if ([29, 30, 35, 41, 42].includes(tipo)) {
                return value && value.length > 0;
            }
            return true;
        }),
    resultados: Yup.array().of(
        Yup.object().shape({
            resultado: Yup.string().test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
                return value !== undefined ? value.length <= 300 : true;
            }).required('Objetivo son requeridos'),
        })
    ).test('min-length', 'Debe haber al menos un resultado en la lista', function (value) {
        const tipo = this.parent.tipo;
        if ([35].includes(tipo)) {
            return value && value.length > 0;
        }
        return true;
    }),
});

export const GuardarFormSchema = Yup.object().shape({
    idproyecto: Yup.string().test('requiredIfProyecto', 'Se debe seleccionar un proyecto', function (value) {
        const tiene = this.parent.tieneProyecto;
        const idpro = this.parent.idproyecto;
        if (tiene === 'S') {
            return idpro > 0;
        }
        return true;
    }),
    tipomotivo: Yup.string().notOneOf(['0', ''], 'No puede ser ninguno'),
    motivo: Yup.string().test('requiredIfmotivo', 'La explicación no puede quedar en blanco.', function (value) {
        const tiene = this.parent.tieneProyecto;
        const motivo: string = this.parent.motivo;
        if (tiene === 'N') {
            return motivo !== undefined && motivo.length > 0;
        }
        return true;
    }).test('motivoLength', 'La longitud del motivo no puede exceder los 300 caracteres.', function (value) {
        const motivo = this.parent.motivo || ''; // Asegúrate de que motivo sea una cadena, si es nulo, lo convierte a una cadena vacía

        // Verifica si la longitud del motivo es igual o inferior a 300 caracteres
        return motivo.trim().length <= 300;
    }),
    titulo: Yup.string().required('El titulo es requerido.')
        .test('requiredIfLegth', 'Se excedio el máximo de caracteres 250', function (value) {
            return value !== undefined ? value.length <= 250 : true;
        }),
    tipo: Yup.number().required('Se debe seleccionar tipo').positive('Debe escoger un Tipo de Producto').min(24, 'Debe escoger un Tipo de Producto Valido'),
});

const filaSchema = Yup.object().shape({
    //cedula: Yup.string().required('La cedula es requerida').matches(/^\d{10}$/, 'La cédula debe tener 10 dígitos'),
    cedula: Yup.string().test('requiredIfcedula', 'La cédula debe tener 10 dígitos', function (value) {
        const tipocolaborador = this.parent.tipocolaborador;
        const cedula = value;
        if (tipocolaborador === 1) {
            return Boolean(cedula && cedula.match(/^\d{10}$/));
        }
        return true;
    }),
    nombre: Yup.string().required('Nombres son requeridos'),
    institucion: Yup.string().required('Institución es requerida'),
    email: Yup.string().email('Correo no válido').required('Correo es requerido'),
    tipoparticipacion: Yup.string().notOneOf(['0'], 'No puede ser ninguno').required('Rol es requerido'),
    idunidad: Yup.string().notOneOf([''], 'No puede ser ninguno').required('Rol es requerido'),
    tipocolaborador: Yup.string().notOneOf(['0'], 'No puede ser ninguno').required('Rol es requerido'),
    // Otras reglas de validación para otros campos de la fila
});

const solicitanteSchema = Yup.object().shape({
    nombre: Yup.string().required('Nombres son requeridos')
        .test('requiredIfLegth', 'Se excedio el máximo de caracteres 150', function (value) {
            return value !== undefined ? value.length <= 150 : true;
        }),
    porcentajetitularidad: Yup.number().typeError('Ingrese valor')
        .min(0, 'El título debe ser mayor o igual a 0')
        .max(100, 'El título debe ser menor o igual a 100')
    // Otras reglas de validación para otros campos de la fila
});

const objEspecificoSchema = Yup.object().shape({
    objetivo: Yup.string().required('Objetivo son requeridos')
        .test('requiredIfLegth', 'Se excedio el máximo de caracteres 500', function (value) {
            return value !== undefined ? value.length <= 500 : true;
        }),
    // Otras reglas de validación para otros campos de la fila
});

const resultadoSchema = Yup.object().shape({
    resultado: Yup.string().max(300, 'Maximo son 300 caracteres').required('Objetivo son requeridos'),
    // Otras reglas de validación para otros campos de la fila
});

